<template>
  <div>
    <div class="searchbar-container">
      <Searchbar
        :containerWidth="mainWrapperWidth"
        :excludeStatusOption="excludeStatusOption"
        :excludeStagesOption="excludeStagesOption"
        :showFilterStatus="showFilterStatus"
        :showFilterStages="showFilterStages"
        :showFilterSession="showFilterSession"
        @statusChange="handleStatusChange"
        @stagesChange="handleStagesChange"
        @sessionChange="handleSessionChange"
      />
    </div>

    <NoDataPage
      v-if="!data.length && !calIsLoading"
      class="no-data-page"
      :imageUrl="require('@/assets/images/propTrade/no_account.png')"
      :tips="$t('propTrade.dashboard.noDataTips')"
    />

    <div v-else class="account-wrapper">
      <template v-if="!calIsLoading">
        <component
          :is="currentComponent"
          :accountData="account"
          :newAccount="account.isNew"
          :containerWidth="mainWrapperWidth"
          v-for="account in pagination.data"
          :key="account.id"
        />
      </template>
      <template v-else>
        <div
          class="skeleton-item"
          :class="{ 'mobile-style': mainWrapperWidth <= 1100 }"
          v-for="(item, index) in 8"
          :key="index"
        ></div>
      </template>
    </div>

    <div v-show="pagination.canNext" class="more-button-wrapper">
      <div class="more-button" @click.prevent="paginationLoadMore" data-testid="paginationLoadMore">
        {{ $t('propTrade.button.viewMore') }}
      </div>
    </div>
  </div>
</template>

<script>
import Searchbar from '@/components/propTrading/components/dashboard/Searchbar.vue';
import Account from '@/components/propTrading/components/dashboard/Account.vue';
import PaymentStatus from '@/components/propTrading/components/dashboard/PaymentStatus.vue';
import paginationMixin from '@/mixins/page/propTrade/pagination';
import NoDataPage from './NoDataPage.vue';
import {
  ACCOUNT_STAGE,
  ACCOUNT_STATUS,
  SESSION_STATUS,
  DEFAULT_TAB_CONTENT_SIZE,
  COMPONENT_NAME
} from '@/constants/propTrade';

export default {
  name: 'DashboardTabContent',
  props: {
    mainWrapperWidth: {
      type: String | Number,
      default: 0
    },
    excludeStatusOption: {
      type: Array,
      default: () => []
    },
    excludeStagesOption: {
      type: Array,
      default: () => []
    },
    showFilterStatus: {
      type: Boolean,
      default: true
    },
    showFilterStages: {
      type: Boolean,
      default: true
    },
    showFilterSession: {
      type: Boolean,
      default: false
    },
    afterStatusChangeHook: {
      type: Function,
      default: () => {}
    },
    afterStagesChangeHook: {
      type: Function,
      default: () => {}
    },
    afterSessionChangeHook: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    accountOrPaymentStatus: {
      type: String,
      default: () => COMPONENT_NAME.ACCOUNT
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Searchbar,
    Account,
    PaymentStatus,
    NoDataPage
  },
  mixins: [paginationMixin],
  data() {
    return {
      status: ACCOUNT_STATUS.ALL,
      stages: ACCOUNT_STAGE.ALL,
      session: SESSION_STATUS.ALL,
      alreadyFirstTimeLoadData: false
    };
  },
  computed: {
    currentComponent() {
      return this.accountOrPaymentStatus;
    },
    calIsLoading() {
      return this.isLoading;
    }
  },
  watch: {
    data: {
      handler(value) {
        this.initPagination(this.data, DEFAULT_TAB_CONTENT_SIZE);
      }
    }
  },
  mounted() {
    console.log('currentComponent', this.currentComponent);
    this.alreadyFirstTimeLoadData = true;
  },
  methods: {
    handleStatusChange(value) {
      this.status = value;
      if (this.alreadyFirstTimeLoadData) this.afterStatusChangeHook(value);
    },
    handleStagesChange(value) {
      this.stages = value;
      if (this.alreadyFirstTimeLoadData) this.afterStagesChangeHook(value);
    },
    handleSessionChange(value) {
      this.session = value;
      if (this.alreadyFirstTimeLoadData) this.afterSessionChangeHook(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.searchbar-container {
  margin-bottom: 16px;
}

.account-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 25px;

  & > div {
    width: 100%;
  }
}

.more-button-wrapper {
  margin-top: 78px;
  margin-bottom: 64px;
  display: flex;
  justify-content: center;
}
.more-button {
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}

.no-data-page {
  min-height: 500px !important;
  background-color: transparent !important;
}

.skeleton-item {
  min-width: 320px;
  max-width: 383px;
  padding: 24px;
  height: 268px;
  background: #cdcfd3;
  border-radius: 12px;
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% {
    background-color: #cdcfd3;
  }
  50% {
    background-color: #e0e0e0;
  }
  100% {
    background-color: #cdcfd3;
  }
}

@media (max-width: 1300px) {
  .account-wrapper {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .account-wrapper {
    grid-template-columns: 1fr;
  }
}
</style>
